import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const SettingsOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="m19.47 6.49-6.46-3.73c-.62-.36-1.39-.36-2.01 0L4.54 6.49c-.62.36-1.01 1.03-1.01 1.74v7.46c0 .72.39 1.38 1.01 1.74L11 21.16c.31.18.66.27 1.01.27s.7-.09 1.01-.27l6.46-3.73c.62-.36 1.01-1.03 1.01-1.74V8.23c0-.72-.39-1.38-1.01-1.74h-.01Zm-.59 9.21c0 .15-.08.28-.21.36l-6.46 3.73c-.13.07-.29.07-.41 0l-6.46-3.73a.408.408 0 0 1-.21-.36V8.24c0-.15.08-.28.21-.36l6.46-3.73a.394.394 0 0 1 .42 0l6.46 3.73c.13.07.21.21.21.36v7.46h-.01Z" />
      <Path d="M12 8.33c-2.03 0-3.67 1.65-3.67 3.67s1.65 3.67 3.67 3.67 3.67-1.65 3.67-3.67S14.02 8.33 12 8.33Zm0 5.75c-1.14 0-2.08-.93-2.08-2.07 0-1.14.93-2.08 2.08-2.08s2.08.93 2.08 2.08-.93 2.07-2.08 2.07Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default SettingsOutlined
